export default "__VITE_ASSET__BTbJ81fP__"